import React from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import styled from "styled-components";

// Layout
import QueueLayout, {
    QueueHeader,
    QueueMain,
    QueueAside
} from "frontend/components/fort/mod/core/Layouts/QueueLayout";

// hooks/context: Order: Parent -> Child -> Child ...
import MessageStackProvider from "frontend/components/core/MessageStack";
import {
    PhotoModBatchesContextProvider,
    LoadMoreButton
} from "frontend/components/fort/mod/photos/hooks/usePhotoModBatches/index.js";
import PhotoModAnimationProviders from "frontend/components/fort/mod/photos/hooks/usePhotoModAnimations/PhotoModAnimationProviders.js";
import PhotoModQueueProvider from "./PhotoModQueueProvider";
import Modal2Provider from "core/Modal2";

// components
import PhotoModQueueHeader from "../PhotoModQueueHeader";
import PhotoModQueueMasthead from "../PhotoModQueueMasthead";
import PhotoModBatches from "../PhotoModBatches";
import PhotoModQueueSidebar from "../PhotoModQueueSidebar";
import PhotoModExpandedModal from "../PhotoModExpandedModal";
import Messages from "../Messages";

// redux
import { closeLargeImageView } from "../../slices/largeImageViewSlice";

// styles
import { convertPxToRem } from "frontend/components/helpers";

export const PhotoModQueueLayoutStyled = styled.div`
    padding: ${convertPxToRem(10)};
`;

// component
export const PhotoModQueueLayout = ({
    moderationType = "VISUAL",
    showOnlySuspendedCreators = false
}) => {
    // hooks
    const dispatch = useDispatch();

    return (
        <PhotoModQueueLayoutStyled>
            <MessageStackProvider>
                <PhotoModBatchesContextProvider
                    moderationType={moderationType}
                    showOnlySuspendedCreators={showOnlySuspendedCreators}
                >
                    <PhotoModAnimationProviders>
                        <PhotoModQueueProvider>
                            <QueueLayout>
                                <Modal2Provider
                                    onClose={() =>
                                        dispatch(closeLargeImageView())
                                    }
                                >
                                    <QueueHeader>
                                        <PhotoModQueueHeader />
                                    </QueueHeader>
                                    <QueueMain>
                                        <PhotoModQueueMasthead />
                                        <PhotoModBatches />
                                        <LoadMoreButton />
                                    </QueueMain>
                                    <QueueAside>
                                        <PhotoModQueueSidebar />
                                    </QueueAside>
                                    <PhotoModExpandedModal />
                                </Modal2Provider>
                            </QueueLayout>
                        </PhotoModQueueProvider>
                    </PhotoModAnimationProviders>
                </PhotoModBatchesContextProvider>
                <Messages />
            </MessageStackProvider>
        </PhotoModQueueLayoutStyled>
    );
};

export default PhotoModQueueLayout;

// prop-types
PhotoModQueueLayout.propTypes = {
    moderationType: PropTypes.string,
    showOnlySuspendedCreators: PropTypes.bool
};
